var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.config.index)?_c(_vm.componentType,{tag:"component"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }